import { Module } from 'vuex';
import { IRootState, client } from '@/store';
import { IProject, ICRUDResponse } from '@/models';
import { DateTime } from 'luxon';

export interface IProjectCalendar {
    entities: object[]
}

export const projectCalendar: Module<IProjectCalendar, IRootState> = {
    namespaced: true,
    state: {
        entities: []
    },
    actions: {
        async getEntities({ commit }, date?: string) {
            const { data } = await client.get<ICRUDResponse<IProject[]>>('project_calendar', {
                params: {
                    date
                }
            })
            commit('setEntities', data);
        },
    },
    mutations: {
        setEntities(state, entities) {
            state.entities = entities
        },
    },
};
